/* WKS custom: gedrag desktop-megamenu (>= 1025 px).
   Disclosure-patroon: link navigeert, pijltjesknop opent/sluit (aria-expanded).
   Muis: open na 250 ms stilstand, sluit 300 ms na verlaten van balk en paneel.
   Toetsenbord: Enter/Spatie opent en zet focus op de eerste link; Escape sluit
   en zet focus terug op de knop; Tab voorbij de laatste link sluit.
   Scrollen > 40 px sluit een met de muis geopend paneel; een met het
   toetsenbord geopend paneel blijft open.
   Daarnaast: Keurmerk-cijfer client-side, 24 uur gecachet in localStorage.
   Endpoint: https://review-data.keurmerk.info/rdata/17939.json
   (velden: stars 0-5, reviewCount). Weergave: stars x 2, 1 decimaal met komma;
   aantal afgerond naar beneden op 50 met een plus. Faalt de fetch of duurt hij
   langer dan 1,5 s, dan blijft de cijferregel verborgen en blijven de twee
   vaste regels staan. */
(function () {
  'use strict';
  if (window.wksDesktopMenuLoaded) return;
  window.wksDesktopMenuLoaded = true;

  var OPEN_VERTRAGING = 250;
  var SLUIT_VERTRAGING = 300;
  var SCROLL_GRENS = 40;

  var nav = document.querySelector('[data-wks-dnav]');
  if (!nav) return;

  var open = null; // { item, panel, toggle, viaToetsenbord, scrollStart }

  function positioneer(item, panel) {
    if (!panel.classList.contains('wks-dnav__panel--mega')) return;
    var balk = item.closest('.header-nav-plain') || item.closest('.header-navigation') || item;
    var balkRect = balk.getBoundingClientRect();
    var itemRect = item.getBoundingClientRect();
    var breedte = Math.min(1280, document.documentElement.clientWidth);
    var links = (document.documentElement.clientWidth - breedte) / 2 - itemRect.left;
    panel.style.width = breedte + 'px';
    panel.style.left = links + 'px';
    panel.style.top = (balkRect.bottom - itemRect.top) + 'px';
  }

  function sluit(focusToggle) {
    if (!open) return;
    open.item.classList.remove('is-open');
    open.toggle.setAttribute('aria-expanded', 'false');
    if (focusToggle) open.toggle.focus();
    open = null;
  }

  function openPaneel(item, viaToetsenbord) {
    var panel = item.querySelector('.wks-dnav__panel');
    var toggle = item.querySelector('.wks-dnav__toggle');
    if (!panel || !toggle) return;
    if (open && open.item !== item) sluit(false);
    positioneer(item, panel);
    item.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    open = { item: item, panel: panel, toggle: toggle, viaToetsenbord: !!viaToetsenbord, scrollStart: window.scrollY };
    if (viaToetsenbord) {
      var eerste = panel.querySelector('a[href]');
      if (eerste) eerste.focus();
    }
  }

  nav.querySelectorAll('[data-wks-dnav-item]').forEach(function (item) {
    var toggle = item.querySelector('.wks-dnav__toggle');
    var openTimer = null;
    var sluitTimer = null;

    item.addEventListener('mouseenter', function () {
      clearTimeout(sluitTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(function () { openPaneel(item, false); }, OPEN_VERTRAGING);
    });
    item.addEventListener('mouseleave', function () {
      clearTimeout(openTimer);
      clearTimeout(sluitTimer);
      sluitTimer = setTimeout(function () {
        if (open && open.item === item && !open.viaToetsenbord) sluit(false);
      }, SLUIT_VERTRAGING);
    });

    if (toggle) {
      toggle.addEventListener('click', function (e) {
        clearTimeout(openTimer);
        var viaToetsenbord = e.detail === 0; // Enter/Spatie geeft detail 0
        if (open && open.item === item) {
          sluit(viaToetsenbord);
        } else {
          openPaneel(item, viaToetsenbord);
        }
      });
    }

    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && open && open.item === item) {
        e.stopPropagation();
        sluit(true);
      }
    });

    item.addEventListener('focusout', function () {
      // Tab voorbij de laatste link (of Shift+Tab eruit) sluit het paneel
      setTimeout(function () {
        if (open && open.item === item && !item.contains(document.activeElement)) sluit(false);
      }, 0);
    });
  });

  document.addEventListener('click', function (e) {
    if (open && !open.item.contains(e.target)) sluit(false);
  });

  function bijScroll() {
    if (open && !open.viaToetsenbord && Math.abs(window.scrollY - open.scrollStart) > SCROLL_GRENS) sluit(false);
  }
  window.addEventListener('scroll', bijScroll, { passive: true });
  document.addEventListener('scroll', bijScroll, { capture: true, passive: true });

  window.addEventListener('resize', function () {
    if (open) positioneer(open.item, open.panel);
  });

  /* Keurmerk-cijfer */
  var CACHE_SLEUTEL = 'wksKeurmerk';
  var CACHE_DUUR = 24 * 60 * 60 * 1000;
  var ENDPOINT = 'https://review-data.keurmerk.info/rdata/17939.json';

  function toonKeurmerk(stars, aantal) {
    var score = Math.round(stars * 2 * 10) / 10;
    if (!(score > 0 && score <= 10) || !(aantal > 0)) return;
    var scoreTekst = score.toFixed(1).replace('.', ',');
    var aantalTekst = Math.floor(aantal / 50) * 50 + '+';
    document.querySelectorAll('[data-wks-keurmerk-score]').forEach(function (rij) {
      var s = rij.querySelector('[data-wks-score]');
      var c = rij.querySelector('[data-wks-count]');
      if (s) s.textContent = scoreTekst;
      if (c) c.textContent = aantalTekst;
      rij.removeAttribute('hidden');
    });
  }

  function laadKeurmerk() {
    try {
      var cache = JSON.parse(localStorage.getItem(CACHE_SLEUTEL) || 'null');
      if (cache && cache.ts && (Date.now() - cache.ts) < CACHE_DUUR) {
        toonKeurmerk(cache.stars, cache.count);
        return;
      }
    } catch (e) { /* cache onleesbaar: gewoon vers ophalen */ }

    var controller = ('AbortController' in window) ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, 1500) : null;
    fetch(ENDPOINT, controller ? { signal: controller.signal } : {})
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (timer) clearTimeout(timer);
        if (!data || !data.stars || !data.reviewCount) return;
        try {
          localStorage.setItem(CACHE_SLEUTEL, JSON.stringify({ stars: data.stars, count: data.reviewCount, ts: Date.now() }));
        } catch (e) { /* opslag vol of geblokkeerd: geen probleem */ }
        toonKeurmerk(data.stars, data.reviewCount);
      })
      .catch(function () { /* fetch mislukt of afgebroken: regel blijft verborgen */ });
  }

  var mqDesktop = window.matchMedia('(min-width: 1025px)');
  if (mqDesktop.matches) {
    laadKeurmerk();
  } else if (mqDesktop.addEventListener) {
    mqDesktop.addEventListener('change', function eenmalig(e) {
      if (e.matches) {
        mqDesktop.removeEventListener('change', eenmalig);
        laadKeurmerk();
      }
    });
  }
})();
